import { httpClient } from "../funcs";

export type RefreshInitiatorTrustResult = {
    self_initiator_trust: unknown;
    support_manual_verification_requested?: boolean;
};

export async function refreshInitiatorTrust(isRetry = false): Promise<RefreshInitiatorTrustResult> {
    const { data } = await httpClient.post("/user/initiator-trust/refresh", {
        is_retry: isRetry,
    });
    return data;
}
